<template>
  <v-app>
    <component :is="layout" :headerlogo="headerLogoUrl" @themeChanged="themeChanged"></component>

    <confirmation-menu
      :visible="menuShow"
      :pos-x="menuPosX"
      :pos-y="menuPosY"
      @answer="confirmationAccept($event)"
    ></confirmation-menu>
    <!-- requestLoadingDialog -->

    <v-row align="center" justify="center">
      <v-dialog v-model="toastShowed" max-width="378">
        <v-card id="toast" class="pa-10 ">
          <v-card-text style="text-align: center">
            <v-container>
              <v-row justify="center">
                <v-img max-width="54" max-height="54" class="justify-center" :src="require('@/assets/icons/'+toastIconToShow)"></v-img>
              </v-row>
              <v-row justify="center">
                <div class="text-h6" :class="toastColor+'--text'">
                  {{ toastMessage }}
                </div>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog v-model="showInactiveModal" max-width="400">
        <v-card class="pa-6">
          <v-card-title>
            {{ $t('inactiveUser.title') }}
          </v-card-title>
          <v-card-text>
            {{ $t('inactiveUser.explainer') }} {{ timerCount }}
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-idle
      :reminders="reminder"
      :duration="logoutTime"
      class="d-none"
      @idle="onidle"
      @remind="onremind"
    >
    </v-idle>
    <v-snackbar
      v-model="noServiceVisible"
      :timeout="-1"
      color="error"
      top
    >
      {{ $t('connectionLost.noServiceMessage') }}
    </v-snackbar>
    <v-snackbar
      v-model="reconnectVisible"

      color="success"
      top
    >
      {{ $t('connectionLost.reconnectMessage') }}
    </v-snackbar>
  </v-app>
</template>

<script>
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'
import eventBus from './event-bus'
import ConfirmationMenu from '@/components/ConfirmationMenu.vue'
import createDynamicTheme from './common/theme'
// import server from './services/api/server.js'
import eventTypes from './eventTypes.js'
export default {
  components: {
    LayoutBlank,
    LayoutContent,
    ConfirmationMenu
  },

  data() {
    return {
      toastShowed: false,
      toastIcon: '',
      toastColor: '',
      toastMessage: '',
      toastDescription: '',
      confirmationDialogShowed: false,
      confirmationTitle: '',
      confirmationText: '',
      requestLoadingDialogShowed: false,

      // confmenu
      menuPosX: 0,
      menuPosY: 0,
      menuTitle: '',
      menuShow: false,

      showInactiveModal: false,
      timerCount: 0,
      logoutTime: 300,
      reminder: [15],

      // heartbeat from server connection check
      noServiceVisible: false,
      reconnectVisible: false,
      timerId: 0,

      headerLogo: null,

      authorizationTimerCount: this.$store.state.remoteConfig.authorizationTimeoutSecs
    }
  },

  computed: {
    layout() {
      if (!this.$route.name) return null
      if (this.$route.meta.layout === 'blank') return 'layout-blank'

      return 'layout-content'
    },
    toastIconToShow() {
      if (this.toastColor === 'success') {
        return 'success-msg.png'
      }
      return 'error-msg.png'
    },
    minutesAndSeconds() {
      const minutes = Math.floor(this.authorizationTimerCount / 60)
      const seconds = this.authorizationTimerCount - minutes * 60
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    },
    headerLogoUrl() {
      return this.headerLogo
    }
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
          }, 1000)
        } else {
          this.showInactiveModal = false
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  created() {
    const usedPageTitle = (this.$store.state.remoteConfig.rdssApiUrl && this.$store.state.remoteConfig.rdssApiUrl.length > 0) ? 'rDSS & rSSP' : 'rSSP'
    document.title = usedPageTitle
  },
  async mounted() {
    eventBus.$on('showToast', ({ icon, type, message }) => {
      this.toastShowed = true
      this.toastIcon = icon
      this.toastColor = type
      this.toastMessage = message
    })

    eventBus.$on('showConfirmationMenu', (opts) => {
      this.menuShow = true
      this.menuTitle = opts.title
      this.menuPosX = opts.posX
      this.menuPosY = opts.posY
    })

    this.logoutTime = parseInt(this.$store.state.remoteConfig.logoutTimeSeconds)
    this.reminder = [parseInt(this.$store.state.remoteConfig.logoutReminderSeconds)]
    // this.logoutTime = 30

    eventBus.$on(eventTypes.HEARTBEAT, this.onHeartbeat)
    eventBus.$on(eventTypes.CONNECTION_LOST, (err) => {
      // console.log('rssp CONNECTION_LOST')
      if ((this.$store.state.currentUser !== null) && (this.$store.state.currentUser.status !== 'SUSPENDED') && (this.$store.state.currentUser.roles?.length > 0) && (this.$store.state.currentUser.roles[0].length > 0)) {
        this.noServiceVisible = true
      }
      console.error(err)
    })
    eventBus.$on(eventTypes.CONNECTION_ESTABLISHED, this.onReconnect)

    eventBus.$on(eventTypes.LOGOUT, this.onLogout)

    if (this.$store.state.currentTheme) {
      // console.debug('RSSP App.vue setting theme', this.$store.state.currentTheme)
      this.setThemeImpl(this.$store.state.currentTheme, false)
    }
  },

  methods: {
    themeChanged(themename) {
      // console.debug('theme changed via combobox', themename)
      this.setTheme(themename)
    },
    startHeartbeatTimer() {
      this.timerId = setTimeout(() => {
        this.noServiceVisible = true
        this.resetHeartbeatTimer()
      }, 31000) // 31 seconds
    },
    resetHeartbeatTimer() {
      clearTimeout(this.timerId)
      this.startHeartbeatTimer()
    },
    async onLogout() {
      // console.log('Forced logout called')
      await this.$auth.logout()
    },
    onHeartbeat() {
      // console.log('rssp onHeartbeat')
      if (this.noServiceVisible) {
        this.noServiceVisible = false
      }
      this.resetHeartbeatTimer()
    },
    onReconnect() {
      // console.log('rssp onReconnect')
      if (this.noServiceVisible) {
        this.noServiceVisible = false
        this.reconnectVisible = true
        clearTimeout(this.timerId)
      }
    },
    confirmationAccept(value) {
      eventBus.$emit('confirmationAccept', { value })
      this.menuShow = false
    },
    async onidle() {
      if (this.$store.state.currentUser) {
        this.showInactiveModal = false
        await this.$auth.logout()
      }
    },
    onremind(time) {
      if (this.$store.state.currentUser) {
        this.showInactiveModal = true
        this.timerCount = time
      }
    },
    setTheme(themename) {
      // console.debug('setTheme', this.$vuetify.theme)

      // theme.global.name.value = themename
      // this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      if (themename === 'i4p') {
        // this.setThemeImpl(this.i4pLightTheme)
        this.setThemeImpl(this.$vuetify.theme.defaults.i4pLightTheme)
      } else
      if (themename === 'Thirdparty Red') {
        // this.setThemeImpl(this.thirdpartyRedLightTheme)
        this.setThemeImpl(this.$vuetify.theme.defaults.thirdpartyRedLightTheme)
      } else
      if (themename === 'Thirdparty Dark') {
        this.setThemeImpl(this.$vuetify.theme.defaults.thirdpartyDarkTheme)
      } else
      if (themename === 'From server config') {
        if ((this.$store.state.remoteConfig.theme) && (this.$store.state.remoteConfig.theme)) {
          const dynamicTheme = createDynamicTheme(this.$store.state.remoteConfig.theme)
          this.setThemeImpl(dynamicTheme)
        } else {
          console.error('No theme definition in server config')
        }
      }

      // this.setThemeImpl(i4pLightTheme)
      // this.setThemeImpl(thirdpartyRedLightTheme)
      // console.debug(themename)
    },
    setThemeImpl(theme, commitToo = true) {
      // close menu
      // this.menu = false
      // console.debug('setThemeImpl', theme)
      const name = theme.name
      this.headerLogo = theme.headerLogo

      if (commitToo) {
        this.$store.commit('setCurrentTheme', theme)
      }
      const light = theme.colors
      // set themes
      Object.keys(light).forEach(i => {
        this.$vuetify.theme.themes.light[i] = light[i]
      })
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name
    }
  }
}
</script>
<style>
@import './styles/main.css'
</style>
<style>
.base-table {
  border-radius: 8px;
  filter: drop-shadow(-2px 2px 4px rgba(0, 0, 0, 0.11));
  width: 100%;
}
.v-btn {
  text-transform: none !important;
  box-shadow: initial;
  border-radius: 7px;
}
.v-card {
  border-radius: 30px;
  /* not works */
}

</style>
